export default __webpack_public_path__ + "assets/models/fbd4cd13c0b47a9cfd1cdf43d2e23ad8.glb";